export default {
    // الأوضاع
    "common.mode.auto": "التوليد والاستخدام الذاتي",
    "common.mode.economy": "النمط الاقتصادي",
    "common.mode.exigency": "النمط الطارئ",
  
    // الأجهزة
    "common.grid": "الشبكة الكهربائية",
    'common.evChargers': 'محطات الشحن',
    'common.evCharger': 'محطة الشحن',
    'common.pv': 'الطاقة الشمسية',
    'common.inverter': 'العاكس',
    'common.pcs': 'العاكس + البطارية',
    'common.terminal': 'الجهاز الطرفي',
    'common.airc': 'التكييف',
    'common.engine': 'المحرك',
    'common.battery': 'البطارية',
    'common.metter': 'عداد الكهرباء',
    'common.other': 'أخرى',
    "common.power": "القدرة",
    "common.powerTotal": "إجمالي القدرة",
    "common.voltage": "الجهد",
    "common.electricity": "الكهرباء",
    "common.current": "التيار",
    "common.homeUsage": "إجمالي أحمال المنزل",
    "common.battery.power": "قدرة البطارية",
  
    // البيانات
    "common.noDataAvailable": 'لا توجد بيانات متاحة حالياً~',
    'common.tips': 'نصيحة',
    "common.reset": "إعادة تعيين",
    "common.currencyUnit": 'ر.س',
    "common.submiting": 'جاري الإرسال، يرجى الانتظار...',
    "common.close": 'إغلاق',
    "common.from": 'من',
    "common.useIn": 'يستخدم في',
    "common.energyPercent": 'نسبة تدفق الطاقة',
    "common.dataFlow": "تدفق البيانات",
    "common.getDataIng": 'جاري الحصول على البيانات، يرجى الانتظار...',
    "common.pageLoading": 'جاري تحميل محتوى الصفحة، يرجى الانتظار...',
    "common.reseting": "جاري إعادة تعيين محتوى الصفحة، يرجى الانتظار...",
    "common.save": 'حفظ',
    "common.onlyNumberTips": "يمكن إدخال الأرقام فقط",
    "common.offline": "غير متصل",
    "common.online": "متصل",
    "common.fault":"عطل",
    "common.charge": "شحن",
    "common.discharge": "تفريغ",
    "common.buy": "شراء",
    "common.sell": "بيع",
    "common.loadingInfo": 'جاري التحميل، يرجى الانتظار...',
  
    // 
    "common.moreFeatures": "المزيد من الميزات",
    "common.confirm": 'تأكيد',
    "common.saveing": "جاري الحفظ، يرجى الانتظار...",
    "common.searchPlacholder": "يرجى إدخال الكلمة المفتاحية للبحث",
    "common.iSee": 'فهمت',
    "common.pageErrorTips1": "عذراً، حدث خطأ في الصفحة~",
    "common.pageErrorTips2": "يرجى المحاولة بتحديث الصفحة أو الاتصال بخدمة العملاء~",
    "common.refresh": "تحديث",
    "common.backToHome": "العودة للصفحة الرئيسية",
    "common.checkTips": "جاري التحقق، يرجى الانتظار...",
    "common.back": "العودة",
    "common.cancel": "إلغاء",
    "common.optional": "اختياري",
    "common.required": "مطلوب",
    "common.status": "الحالة",
    "common.statusNoDelete": "غير محذوف",
    "common.statusDelete": "محذوف",
    "common.submit": 'إرسال',
    "common.disable": "تعطيل",
    "common.enable": "تفعيل",
    "common.year": 'سنة',
    "common.month": 'شهر',
    "common.day": 'يوم',
    "common.version": 'رقم الإصدار：',
    "common.backHome": ' العودة للصفحة الرئيسية',
    "common.backHomeSorry": ' نعتذر، الصفحة ضلت طريقها بطريق الخطأ',
    "common.requestTips1": 'البيانات قيد المعالجة، يرجى عدم الإرسال مرة أخرى',
    "common.requestTips2": "تنبيه النظام",
    "common.requestTips3": "انتهت صلاحية حالة تسجيل الدخول، يرجى تسجيل الدخول مجدداً",
    "common.requestTips4": "تسجيل الدخول مجدداً",
    "common.requestTips5": "جلسة غير صالحة أو منتهية الصلاحية، يرجى تسجيل الدخول مجدداً.",
    "common.requestTips6": "الخادم gặp مشكلة، يرجى المحاولة لاحقًا.",
    "common.requestTips7": "انتهت مهلة طلب واجهة النظام",
    "common.requestTips8": 'واجهة النظام',
    "common.requestTips9": 'استثناء',
    "common.iknow": 'فهمت',
    "common.logoutSuccess": "تم الخروج بنجاح",
    
    // مكون اعرف المزيد
    "common.knowMore.title": 'تريد معرفة المزيد، يرجى الاتصال ببيننغ',
    "common.knowMore.email": 'البريد الإلكتروني للتواصل',
    "common.knowMore.phone": 'رقم الهاتف للتواصل',
    "common.knowMore.wechat": 'ويتشات للتواصل',
    "common.knowMore.website": 'عنوان الموقع الرسمي',
    "common.knowMore.address": 'عنوان التواصل',
    "common.knowMore.addressDetail": 'الغرفة 1205، 1301، المبنى رقم 5، 8 طريق تشينغخه، هوانغجينغكنغ، بلدة هوانغجيانغ، دونغقوان، مقاطعة قوانغدونغ',
    
    // مكون الاتصال المحلي
    "common.localConnection": 'الاتصال المحلي',
    "common.operateInApp": 'يرجى التشغيل في التطبيق!',
    
    "common.enbleStaus": "حالة التفعيل",
    "common.battery.status": "لا شحن ولا تفريغ",
  
    'account.forgetThePassword': 'نسيان كلمة المرور',
      'account.logInDirectly': 'الذهاب لتسجيل الدخول مباشرة',
      'account.tips1': 'جاري انتقال الصفحة، يرجى الانتظار...',
      'account.tips2': 'يرجى قراءة شروط المستخدم والموافقة عليها أولاً！',
      'account.autoLogin': 'تسجيل الدخول التلقائي',
      'account.userLogin': 'تسجيل دخول المستخدم',
      'account.registerTips': 'ليس لديك حساب؟ انقر هنا للتسجيل',
      'account.userEmail': 'اسم المستخدم/البريد الإلكتروني',
      'account.userEmailTips': 'يرجى إدخال اسم المستخدم/البريد الإلكتروني',
      'account.password': 'كلمة المرور',
      'account.passwordTips': 'يرجى إدخال كلمة المرور',
      'account.submit': 'إرسال',
      'account.submitTips': 'جاري الإرسال، يرجى الانتظار...',
      'account.otherLoginTips': 'أو اختر طريقة تسجيل دخول أخرى',
      'account.userRegistration': 'تسجيل مستخدم',
      'account.userName': 'ازن المستخدم',
      'account.userNameTips': 'يرجى إدخال اسم المستخدم',
      'account.emailTips1': 'يرجى إدخال عنوان البريد الإلكتروني',
      'account.emailTips2': 'تنسيق عنوان البريد الإلكتروني غير صحيح',
      'account.phone': 'رقم الهاتف',
      'account.phoneTips1': 'يرجى إدخال رقم الهاتف',
      'account.phoneTips2': 'رقم الهاتف غير صحيح',
      'account.phoneTips3': 'يرجى إدخال رقم الهاتف',
      'account.passwordTips1': 'يرجى إدخال كلمة مرور من 6-30 رقم',
      'account.passwordTips2': 'تنسيق كلمة المرور غير صحيح، تتكون كلمة المرور من حروف إنجليزية وأرقام وعلامات الترقيم والشرطات والنقاط، بطول 6-12 رقم',
      'account.passwordTips3': 'كلمتا المرور غير متطابقتين، يرجى التحقق وإعادة الإدخال！',
      'account.passwordTips4': 'يرجى إدخال كلمة المرور، تتكون كلمة المرور من حروف إنجليزية وأرقام وعلامات الترقيم والشرطات والنقاط',
      'account.passwordTips5': 'تأكيد كلمة المرور',
      'account.passwordTips6': 'يرجى إدخال تأكيد كلمة المرور',
      'account.passwordTips7': 'كلمتا المرور غير متطابقتين، يرجى التحقق وإعادة الإدخال！',
      'account.passwordTips8': 'يرجى إدخال تأكيد كلمة المرور',
      'account.passwordTips9': 'تهانينا! تم التسجيل بنجاح！',
      'account.passwordTips10': 'اسم المستخدم الخاص بك:',
      'account.emailIs': 'البريد الإلكتروني هو:',
      'account.goToLoginPage': 'sبعد سيتم الانتقال تلقائياً لصفحة تسجيل الدخول',
      'account.goLogin': 'اذهب لتسجيل الدخول',
      'account.goRegister': 'تسجيل',
      'account.loginSuccess': 'تم تسجيل الدخول بنجاح',
      'account.email': 'البريد الإلكتروني',
      'account.sologn': 'نبتكر بعناية حلول الطاقة الخاصة بك',
      'account.pleaseAgree': 'لقد قرأت وأوافق على',
      'userAgreement.privacyPolicy': 'سياسة الخصوصية',
  
      "account.code": "رمز التحقق",
      "account.codeTips": "يرجى إدخال رمز التحقق",
      "account.codeTips2": "رمز التحقق غير صحيح",

    "account.inviteCodeTips": "يرجى إدخال رمز الدعوة",
    "account.inviteCodeHint": "يرجى التواصل مع فني التركيب أو موظف التشغيل والصيانة للحصول على رمز الدعوة",  
      "account.modifyPasswordByAccount": "تغيير كلمة المرور بالحساب",
      "account.modifyPasswordByEmail": "تغيير كلمة المرور بالبريد الإلكتروني",
      "account.getPasswordByAccount": "استرداد كلمة المرور بالحساب",
      "account.getPasswordByEmail": "استرداد كلمة المرور بالبريد الإلكتروني",
  
      "account.sendEmailTips": "تم إرسال رمز التحقق إلى البريد الإلكتروني، يرجى مراجعة البريد الإلكتروني",
      "account.name": "اسم الحساب",
      "account.newPassword": "كلمة المرور الجديدة",
      "account.confirmNewPassword": "تأكيد كلمة المرور الجديدة",
      "account.nameTips": "يرجى إدخال اسم الحساب",
      "account.passwordModifySuccess": "تم تعديل كلمة المرور بنجاح",
      "account.emailCode": "رمز التحقق من البريد الإلكتروني",
      "account.emailCodeTips": "يرجى إدخال رمز التحقق من البريد الإلكتروني",
      "account.emailCodeTips2": "رمز التحقق من البريد الإلكتروني غير صحيح",
      "account.emailModifySuccess": "تم تعديل كلمة المرور بنجاح",
      "account.passworTips1": "تم إعادة تعيين كلمة المرور بنجاح!",
      "account.passwordTips11": "يرجى إدخال تأكيد كلمة المرور",
      "account.passwordTips12": "يرجى إدخال كلمة المرور الجديدة",
      "account.nickname": "الاسم المستعار للمستخدم",
      "account.modifyNickname": "تعديل الاسم المستعار للمستخدم",
      "account.modifyNicknameSuccess": "تم تعديل الاسم المستعار للمستخدم بنجاح!",
      "account.nicknameTips": "يرجى إدخال الاسم المستعار للمستخدم",
      'account.nicknameError': 'فشل تعديل الاسم المستعار للمستخدم!',
  
      "account.login": 'تسجيل الدخول',
      'account.quickRegister': 'التسجيل السريع',
      'account.sendCode': 'إرسال رمز التحقق',
      'account.sendTips': 'يمكن الإعادة بعد s',
      "account.sendEmailIng": 'جاري إرسال البريد الإلكتروني، يرجى الانتظار...',
      'account.emailNotEmpty': 'لا يمكن أن يكون عنوان البريد الإلكتروني فارغاً',
      'account.registerAccount': 'تسجيل الحساب',
      'account.registerWelcome': 'مرحباً بك في تسجيل SusprSafe',
      'account.usernameLimit': 'يجب أن يبدأ اسم المستخدم بحرف، ويحتوي فقط على حروف وأرقام وشرطات سفلية، بطول 5-15 حرف',
  
      'copyright.desc2': 'معلومات تسجيل الموقع: 粤ICP备2021169764号',
  
      'editUserInfo.editUserInformation': 'تحرير معلومات المستخدم',
      'editUserInfo.modifyUsername': 'تعديل اسم المستخدم',
      'editUserInfo.changePictures': 'تعديل الصورة الرمزية',
      'editUserInfo.savePicturesSuccess': 'تم حفظ الصورة الرمزية للمستخدم بنجاح',
      'editUserInfo.saveError': 'فشل الحفظ',
      'editUserInfo.pictureLimit':'يجب أن تكون الصورة أصغر من 2 ميجابايت',
      'editUserInfo.uploadPicture':'رفع الصورة الرمزية',
      'editUserInfo.picturePreview':'معاينة',
      
      'editUserInfo.bindPhoneNumber': 'ربط رقم الهاتف',
      'editUserInfo.bindEmail': 'ربط البريد الإلكتروني',
      'editUserInfo.changePassword': 'تعديل كلمة المرور',
  
      'editUserInfo.notificationSettings': 'إعدادات الإشعارات',
      'editUserInfo.editAccount': 'تحرير معلومات حساب المستخدم',
      'editUserInfo.waitBingting': 'جاري الربط، يرجى الانتظار...',
      'editUserInfo.collapse': 'طي',
      'editUserInfo.modifyBinding': 'تعديل الربط',
      
      'editUserInfo.emailAddress': 'عنوان البريد الإلكتروني',
      'editUserInfo.tips1': 'تم ربط البريد الإلكتروني بنجاح',
      'editUserInfo.tips2': 'فشل الحفظ',
      'editUserInfo.tips3': 'جاري إرسال رمز التحقق للبريد الإلكتروني، يرجى الانتظار...',
      'editUserInfo.tips4': 'تم إرسال رمز التحقق إلى البريد الإلكتروني xxxx، يرجى المراجعة',
      'editUserInfo.tips5': 'فشل إرسال رمز التحقق!',
      'editUserInfo.tips6': 'تم ربط رقم الهاتف',
      'editUserInfo.tips7': 'تم ربط البريد الإلكتروني',
      'editUserInfo.emailTips1': 'يرجى إدخال عنوان البريد الإلكتروني',
      'editUserInfo.emailTips2': 'تنسيق عنوان البريد الإلكتروني غير صحيح',
      'editUserInfo.emailTips3': 'يمكن الإعادة بعد xxxxs',
      'editUserInfo.emailTips4': 'إرسال رمز التحقق',
      'editUserInfo.emailTips5': 'لا يمكن أن يكون رمز التحقق من البريد الإلكتروني فارغاً',
      'editUserInfo.emailTips6': 'رمز التحقق من البريد الإلكتروني غير صحيح',
      'editUserInfo.emailCode': 'رمز التحقق من البريد الإلكتروني',
      'editUserInfo.save': 'حفظ',
  
      'editUserInfo.phoneTips1': 'تم ربط رقم الهاتف بنجاح',
      'editUserInfo.phoneTips2': 'جاري إرسال رمز التحقق للهاتف، يرجى الانتظار...',
      'editUserInfo.phoneTips3': 'تم إرسال رمز التحقق النصي إلى الهاتف xxxx، يرجى المراجعة',
      'editUserInfo.phoneTips4': 'فشل إرسال رمز التحقق النصي!',
      'editUserInfo.phoneTips5': 'يرجى إدخال رقم الهاتف',
      'editUserInfo.phoneTips6': 'تنسيق رقم الهاتف غير صحيح',
      'editUserInfo.phoneTips7': 'إرسال رمز التحقق النصي',
      'editUserInfo.phoneTips8': 'رمز التحقق النصي',
      'editUserInfo.phoneTips9': 'لا يمكن أن يكون رمز التحقق من الهاتف فارغاً',
      'editUserInfo.phoneTips10': 'رمز التحقق من الهاتف غير صحيح',
      'editUserInfo.phone': 'رقم الهاتف',
  
  
      'editUserInfo.noticeTips1': 'فشل الحصول على إعدادات الإشعارات!',
      'editUserInfo.noticeTips2': 'تم حفظ إعدادات الإشعارات بنجاح!',
      'editUserInfo.noticeTips3': 'إشعار انخفاض شحن البطارية',
      'editUserInfo.noticeTips4': 'إشعار اكتمال شحن محطة الشحن',
      'editUserInfo.errorNotification': 'إشعارات الأخطاء',
      'editUserInfo.updateNotification': 'إشعارات التحديث والترقية',
      'editUserInfo.monthlyStatisticsNotification': 'إشعارات الإحصائيات الشهرية',
      'editUserInfo.notificationMethod': 'طريقة الاستلام',
  
      'editUserInfo.userNameTips1': 'تم حفظ اسم المستخدم بنجاح',
      'editUserInfo.userNameTips2': 'فشل حفظ اسم المستخدم',
      'editUserInfo.userNameTips3': 'يرجى إدخال اسم المستخدم',
      'editUserInfo.userNameTips4': 'تنسيق اسم المستخدم غير صحيح، يجب أن يتكون من أرقام وشرطات سفلية وحروف إنجليزية',
      'editUserInfo.userNameTips5': 'يرجى إدخال اسم المستخدم',
      'editUserInfo.userNameTips6': 'جاري الحفظ، يرجى الانتظار...',
      'editUserInfo.userName': 'اسم المستخدم',
  
      'editUserInfo.avatorTips': 'انقر لتعديل الصورة الرمزية',
      'editUserInfo.verifyCodeTips1': 'يرجى إدخال رمز التحقق الذي تلقيته:',
      'editUserInfo.verifyCodeTips2': 'لأمان حسابك، يرجى النقر على الزر أدناه لإرسال رمز التحقق إلى رقم الهاتف الأصلي:',
      'editUserInfo.verifyCodeTips3': 'إرسال رمز التحقق',
      'editUserInfo.verifyCodeTips4': 'تم التحقق من الهاتف الأصلي، يرجى إدخال رقم الهاتف الجديد للربط',
      'editUserInfo.verifyCodeTips5': 'لأمان حسابك، يرجى النقر على الزر أدناه لإرسال رمز التحقق إلى البريد الإلكتروني الأصلي:',
      'editUserInfo.verifyCodeTips6': 'تم التحقق من البريد الإلكتروني الأصلي، يرجى إدخال البريد الإلكتروني الجديد',
      'editUserInfo.verifyCodeTips7': 'كلمة المرور القديمة',
      'editUserInfo.verifyCodeTips8': 'يرجى ربط البريد الإلكتروني أولاً!',
      'editUserInfo.verifyCodeTips9': 'تم إرسال رمز التحقق إلى البريد الإلكتروني، يرجى المراجعة',
      "editUserInfo.verifyCodeTips10": '، سيتم الانتقال تلقائياً إلى صفحة تسجيل الدخول',
  
      "hems.notice.title": "عنوان الإشعار", 
     "hems.notice.content": "محتوى الإشعار", 
     "hems.notice.operate": "العملية",
     "hems.notice.noRead": "غير مقروء",
     "hems.notice.read": "مقروء",
     "hems.notice.warning": "تذكير",
     "hems.notice.error": "استثناء",
     "hems.notice.success": "تسوية إحصائية",
     "hems.notice.sys": "معلومات النظام",
     "hems.notice.operateSuccess": "تمت العملية بنجاح",
     "hems.notice.operateTips": "يرجى اختيار العنصر المراد تشغيله",
  
      // الصفحة الرئيسية
     "hems.home.selfuseRate": "معدل التوليد والاستخدام الذاتي",
     "hems.home.percent": "النسبة المئوية",
     "hems.home.todayData": "بيانات اليوم",
     "hems.home.todayPowerGeneration": "توليد الطاقة اليوم",
     "hems.home.salesIncome": "دخل بيع الكهرباء",
     "hems.home.saved": "تم توفير",
     "hems.home.reduce": "تقليل البصمة الكربونية",
     "hems.home.tips1": "لا توجد بيانات، لم تقم بربط xxxx بعد",
     "hems.home.criticalLoad": "الحمولة الحرجة",
     "hems.home.keyVoltage": "الجهد الحرج",
     "hems.home.householdLoad": "الحمولة المنزلية",
     "hems.home.householdVoltage": "الجهد المنزلي",
     "hems.home.generalLoad": "الحمولة العامة",
     "hems.home.generalVoltage": "الجهد العام",
     "hems.home.batteryHealth": "صحة البطارية",
     "hems.home.averageTemp": "متوسط درجة الحرارة",
     "hems.home.gridLoad": "حمولة الشبكة",
     "hems.home.toggeleDataSource": "تم التبديل إلى عرض البيانات الحالية:",
     "hems.home.toggleTips": "هل أنت متأكد من التبديل؟",
     "hems.home.modeSending": "جاري إرسال أمر الوضع، يرجى الانتظار...",
     "hems.home.modeSuccess": "تم إرسال أمر تبديل الوضع بنجاح!",
     "hems.home.isOnline": "هل متصل",
     "hems.home.useStatus": "حالة الاستخدام",
     "hems.home.workModeText": 'وضع العمل الحالي:',
     "hems.home.toggleDataSourceText": 'تم التبديل إلى عرض البيانات الحالية:',
     "hems.ev.charge.status": "حالة الشحن",
     "hems.ev.charge.time": "مدة الشحن",
     "hems.ev.charge.count": "كمية الشحن الفورية",
     "hems.ev.charge.status.empty":"فارغ",
     "hems.ev.charge.status.ing":"الشحن بالمسدس متصل",
     "hems.ev.charge.status.null":"المسدس متصل لكن لا يشحن",
     "hems.ev.charge.status.error":"عطل",
     "hems.hour":"ساعة",
     "hems.minue":"دقيقة",
     "hems.ev.chagre.number": "رقم محطة الشحن",
  
     // دليل المستخدم
     "hems.userGuide.selfUse": "التوليد والاستخدام الذاتي",
     "hems.userGuide.selfUseTips": "استخدام الطاقة الشمسية أولاً، والتكميل من الشبكة عند النقص",
     "hems.userGuide.economyMode": "النمط الاقتصادي",
     "hems.userGuide.economyModeTips": "تحسين استراتيجية الاستهلاك بناءً على أسعار الكهرباء",
     "hems.userGuide.emergencyMode": "النمط الطارئ",
     "hems.userGuide.emergencyModeTips": "إعطاء الأولوية لضمان إمدادات الأحمال الحرجة",
  
     // صفحة الرسوم البيانية
     "hems.history.energyStatistics": "إحصائيات الطاقة",
     "hems.history.revenueStatistics": "إحصائيات الإيرادات",
     "hems.history.greenStatistics": "إحصائيات الحد من الانبعاثات الخضراء",
     "hems.history.revenueTitle": "إجمالي دخل بيع الكهرباء",
     "hems.history.savingsTitle": "إجمالي التوفير",
     "hems.history.carbonTitle": "إجمالي تقليل انبعاثات الكربون",
     "hems.history.day": "يوم",
     "hems.history.month": "شهر",
     "hems.history.year": "سنة",
     "hems.history.beforeDay": "اليوم السابق",
     "hems.history.afterDay": "اليوم التالي",
     "hems.history.beforeMonth": "الشهر السابق",
     "hems.history.afterMonth": "الشهر التالي",
     "hems.history.beforeYear": "السنة السابقة",
     "hems.history.afterYear": "السنة التالية",
     "hems.history.totalUse": 'إجمالي الاستخدام',
     "hems.history.fullScreen": 'ملء الشاشة',
     "hems.history.timeSelect": "اختيار التاريخ",
     "sync.tips1": "تم إرسال أمر مزامنة البيانات بنجاح!",
     "sync.tips2":"مزامنة البيانات جارية، نظراً لحجم البيانات الكبير، تحتاج عملية المزامنة إلى بعض الوقت، يرجى المراجعة بعد نصف ساعة~",
     "sync.tips3": "قد تتأخر مزامنة بيانات الجهاز، في حالة اكتشاف خلل في البيانات، يرجى النقر على:",
     "sync.tips4": "مزامنة البيانات",
  
     "charge.info": "معلومات محطة الشحن",
      "news.loading": 'جاري التحميل...',
      "news.noMore": 'لا يوجد المزيد',
      "hems.pv.power": 'كمية الطاقة الشمسية',
  
    // UEH محدد
    "ueh.sellPower": "كمية بيع الكهرباء",
    
    "menu.home": "الصفحة الرئيسية",
    "menu.history": "البيانات التاريخية",
    "menu.device": "الجهاز",
    "menu.settings": "الإعدادات",
    "menu.messageCenter": "مركز الرسائل",
    "menu.help": "المساعدة والدعم",
    "menu.mine": "حسابي",
  
  
    "mine.userSetting": "إعدادات المستخدم",
    "mine.terminalSetting": "الإعدادات الأساسية للطرفية",
    "mine.uploadCloud": "نسخ احتياطي للبيانات في السحابة",
    "mine.changeVersion": "فحص التحديثات",
    "mine.language": "تبديل اللغة",
    "mine.about": "حول",
    "mine.feedback": "الآراء والتعليقات",
    "mine.logout": "تسجيل الخروج",
    "mine.logoutAccount": "إلغاء الحساب",
  
    "mine.logoutAccountTips": "إلغاء الحساب باسم []",
    "mine.logoutAccountTips1": "إلغاء الحساب المربوط بـ []",
    "mine.logoutAccountCare": "الأمور المرتبطة بطلب الإلغاء:",
    "mine.logoutAccountCare1": "1. الحساب في حالة آمنة",
    "mine.logoutAccountCare1-1": "الحساب حالياً في حالة استخدام عادية، ولا توجد مخاطر مثل السرقة أو الانتهاك أو التعطيل.",
    "mine.logoutAccountCare2": "2. تم إلغاء تفويض الحساب وعلاقات الربط",
    "mine.logoutAccountCare2-1": "تم إلغاء تفويض الحساب مع منصات الطرف الثالث الأخرى وما إلى ذلك.",
    "mine.logoutAccountCare3": "3. لا يمكن استرداد الحساب بعد الإلغاء، وسيتم مسح جميع بيانات المستخدم",
    "mine.logoutAccountCare3-1": "بعد إلغاء الحساب، سيتم مسح الهاتف المحمول والبريد الإلكتروني المربوطان والبيانات ذات الصلة ولا يمكن استردادها.",
    "mine.confirmLogout": "تأكيد الإلغاء",
    "mine.logoutSuccess": "تم حذف الحساب بنجاح!",
  
  
    "mine.feedbackIssues": "الإبلاغ عن مشكلة",
    "mine.feedQuantity": "الكمية",
    "mine.feedAmount": "حد أقصى 9 صور، بحد أقصى 1 ميجابايت لكل صورة",
  
    "mine.notice.fail": "فشل الحصول على إعدادات الإشعارات!",
    "mine.notice.saveSuccess": "تم حفظ إعدادات الإشعارات بنجاح!",
    "mine.notice.saveFail": "فشل الحفظ!",
    "mine.notice.title": "إعدادات الإشعارات",
    "mine.notice.batteryLow": "إشعار انخفاض شحن البطارية",
    "mine.notice.chargingFinish": "إشعار اكتمال شحن محطة الشحن",
    "mine.notice.error": "إشعارات الأخطاء",
    "mine.notice.update": "إشعارات التحديث والترقية",
    "mine.notice.monthly": "إشعارات الإحصائيات الشهرية",
    "mine.notice.receiveType": "طريقة الاستلام",
  
    "mine.language.welcome": "مرحباً بك في استخدام SusprSafe",
    "mine.language.desc1": "يرجى تعيين إصدار اللغة وفقاً لمنطقتك",
    "mine.language.desc2": "يمكنك التغيير في أي وقت من خلال إعدادات التطبيق",
  
    "mine.userInfo.avatar":"الصورة الرمزية",
    "mine.userInfo.nickname":"الاسم المستعار",
    "mine.userInfo.password":"كلمة المرور",
    "mine.userInfo.changePassword":"تعديل كلمة المرور",
    "mine.userInfo.setPassword":"تعيين كلمة المرور",
    "mine.userInfo.phoneNumber":"رقم الهاتف",
    "mine.userInfo.bindPhone":"ربط رقم الهاتف",
    "mine.userInfo.bindEmail":"ربط البريد الإلكتروني",
    "mine.loginExpired":"انتهت صلاحية تسجيل الدخول، يرجى تسجيل الدخول مجدداً",
    "mine.userInfo.title":"معلومات المستخدم",
    "mine.userInfo.bind":"ربط",
    "mine.userInfo.modify": "تعديل",
    "mine.userInfo.modifyNickname":"تعديل الاسم المستعار",
    "mine.userInfo.userNickname":"الاسم المستعار للمستخدم",
    "mine.userInfo.selectPic":"يرجى اختيار الصورة المراد رفعها",
    "mine.userInfo.saveSuccess":"تم الحفظ بنجاح",
    "mine.userInfo.uploadFail":"فشل الرفع",
    "mine.userInfo.avatarSaveSuccess":"تم حفظ الصورة الرمزية بنجاح",
    "mine.userInfo.nameTips1":"لا يمكن أن يكون الاسم المستعار للمستخدم فارغاً",
    "mine.userInfo.nameTips2":"يرجى إدخال الاسم المستعار للمستخدم",
  
    "common.pleaseSelect": "يرجى الاختيار",
    "question.commonQuestions": "الأسئلة الشائعة",
    "account.toggleLanguage": 'تبديل اللغة',
    "account.localConnection": "الاتصال المحلي",
    "account.selectLanguage": 'يرجى اختيار اللغة',
    "account.sendEmailToast": "تم إرسال رمز التحقق إلى البريد الإلكتروني xxx، يرجى المراجعة",
    "account.emailError": "تنسيق البريد الإلكتروني غير صحيح",
    "account.sendEmailFail": "فشل الإرسال، يرجى المحاولة مجدداً",
    
    "common.submitting": "جاري الإرسال، يرجى الانتظار...",
  
    "device.page.noData": "لا توجد بيانات، هذه الصفحة تحتاج للمعاينة في التطبيق",

  // OTA Upgrade
  "bmsFirmware.upgrade": "تحديث",
  "bmsFirmware.upgrading": "جاري التحديث...",
  "bmsFirmware.uploadingFile": "جاري رفع ملف البرنامج الثابت...",
  "bmsFirmware.upgradingProgress": "جاري تحديث البرنامج الثابت... {progress}%",
  "bmsFirmware.upgradeSuccess": "تم التحديث بنجاح",
  "bmsFirmware.upgradeSuccessSubtitle": "تم إنجاز تحديث برنامج BMS الثابت!",
  "bmsFirmware.upgradeFailed": "فشل التحديث",
  "bmsFirmware.upgradeFailedFormError": "يرجى التحقق من ملء النموذج بشكل صحيح",
  "bmsFirmware.upgradeFailedNetworkError": "خطأ في الشبكة، يرجى المحاولة مرة أخرى",
  "bmsFirmware.invalidFileType": "يرجى اختيار ملف برنامج ثابت صالح (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "يرجى اختيار ملف البرنامج الثابت أولاً",
  "bmsFirmware.statusUpgrading": "جاري التحديث",
  "bmsFirmware.statusCompleted": "تم إنجاز التحديث",
  "bmsFirmware.statusFailed": "فشل التحديث",
  "bmsFirmware.deviceUpgrading": "جاري تحديث حزمة البرنامج الثابت، يستغرق التحديث 30 إلى 50 دقيقة، لا يمكن عرض بيانات الجهاز في الوقت الفعلي خلال هذه الفترة، يرجى الانتظار...",
  "bmsFirmware.upgradeStatusLabel": "حالة التحديث",
  "bmsFirmware.upgradeProgressLabel": "تقدم التحديث",
  "bmsFirmware.currentPackageLabel": "رقم حزمة البيانات المرسلة حالياً",
  "bmsFirmware.totalPackagesLabel": "إجمالي حزم البيانات",
  "bmsFirmware.upgradeFailedCheckDevice": "يرجى فحص حالة الجهاز وإعادة محاولة التحديث",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "تم الإعداد بنجاح",
  "settingResult.defaultSubTitle": "تم حفظ إعدادات المعاملات",
  "settingResult.confirmButton": "موافق"
   
  };